// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-05-07",
  "topic": "德州扑克新手教程 / 德州扑克规则 / 德州扑克新手规则",
  "metaKeywords": "德州扑克新手教程, 德州扑克规则, 德州扑克新手规则, 德州扑克入门教程, 德州扑克平台怎么选, 德州扑克平台下载, 德扑平台安装教程, 德州扑克平台客服, hhpoker官网, hhpoker最新下载",
  "focusKeywords": [
    {
      "keyword": "德州扑克新手教程",
      "path": "/guide",
      "anchorText": "德州扑克新手教程"
    },
    {
      "keyword": "德州扑克规则",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德州扑克规则详解"
    },
    {
      "keyword": "德州扑克新手规则",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德州扑克新手规则攻略"
    },
    {
      "keyword": "德州扑克入门教程",
      "path": "/texas-poker-complete-guide",
      "anchorText": "德州扑克入门教程"
    },
    {
      "keyword": "德州扑克平台怎么选",
      "path": "/guide",
      "anchorText": "德州扑克平台怎么选入口"
    },
    {
      "keyword": "德州扑克平台下载",
      "path": "/download",
      "anchorText": "德州扑克平台下载指南"
    },
    {
      "keyword": "德扑平台安装教程",
      "path": "/install-guide",
      "anchorText": "德扑平台安装教程"
    },
    {
      "keyword": "德州扑克平台客服",
      "path": "/contact",
      "anchorText": "德州扑克平台客服通道"
    },
    {
      "keyword": "hhpoker官网",
      "path": "/",
      "anchorText": "hhpoker官网教程"
    },
    {
      "keyword": "hhpoker最新下载",
      "path": "/download",
      "anchorText": "hhpoker最新下载"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克新手教程 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德州扑克新手教程。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克规则 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德州扑克规则。"
      },
      "linkPath": "/texas-poker-complete-guide"
    },
    {
      "name": "德州扑克新手规则 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德州扑克新手规则。"
      },
      "linkPath": "/texas-poker-complete-guide"
    },
    {
      "name": "德州扑克入门教程 怎么操作更稳妥？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "建议先访问对应专题页查看完整步骤，再结合设备系统和当前版本执行，可明显减少重复排障时间。关键词：德州扑克入门教程。"
      },
      "linkPath": "/texas-poker-complete-guide"
    }
  ]
};

export default dailySeoContent;
